import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import MaterialIcon from "shared/react_components/MaterialIcon";

const ChoiceIcon = ({ spriteIcon, materialIcon }) => {
  return (
    <div className="card-icon icons-sprite icon-background">
      {spriteIcon && <span className={classNames("icons-sprite", spriteIcon)}/>}
      {materialIcon && <MaterialIcon name={materialIcon}/>}
    </div>
  );
};

ChoiceIcon.propTypes = {
  spriteIcon: PropTypes.string,
  materialIcon: PropTypes.string
};

export default ChoiceIcon;
